import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EProductDraftAutoSaveStatus } from '@api-ui-app/src/app/e-commerce-stores/types/e-product-draft-auto-save-status.enum';
import { SECOND } from '@gelato-api-ui/utils/time';

@Component({
  selector: 'ui-ecommerce-product-wizard-autosave-status',
  templateUrl: './ecommerce-product-wizard-autosave-status.component.html',
  styleUrls: ['./ecommerce-product-wizard-autosave-status.component.scss'],
})
export class EcommerceProductWizardAutosaveStatusComponent implements OnChanges {
  @Input() status: EProductDraftAutoSaveStatus;

  private isSavedRecently = false;
  private autoSaveCompleteSuccessMessageTimer = null;
  private readonly autoSaveCompleteSuccessMessageTimeout = 5 * SECOND;

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.status) {
      const { currentValue, previousValue } = changes.status;

      if (currentValue === EProductDraftAutoSaveStatus.IN_PROGRESS) {
        this.isSavedRecently = false;
        this.clearAutoSaveCompleteSuccessMessageTimer();
      } else if (
        currentValue === EProductDraftAutoSaveStatus.SUCCESS &&
        previousValue === EProductDraftAutoSaveStatus.IN_PROGRESS
      ) {
        this.isSavedRecently = true;
        this.setAutoSaveCompleteSuccessMessageTimer();
      }
    }
  }

  get translationKey(): string {
    switch (this.status) {
      case EProductDraftAutoSaveStatus.IN_PROGRESS:
        return 'txt_e_commerce_product_autosave_status_in_progress';
      case EProductDraftAutoSaveStatus.SUCCESS:
        return this.isSavedRecently
          ? 'txt_e_commerce_product_autosave_status_complete_recently'
          : 'txt_e_commerce_product_autosave_status_complete';
      default:
        return null;
    }
  }

  get ngClass(): object {
    return {
      success:
        this.status === EProductDraftAutoSaveStatus.IN_PROGRESS ||
        (this.status === EProductDraftAutoSaveStatus.SUCCESS && this.isSavedRecently),
    };
  }

  private clearAutoSaveCompleteSuccessMessageTimer() {
    if (this.autoSaveCompleteSuccessMessageTimer) {
      clearTimeout(this.autoSaveCompleteSuccessMessageTimer);
    }

    this.autoSaveCompleteSuccessMessageTimer = null;
  }

  private setAutoSaveCompleteSuccessMessageTimer() {
    this.clearAutoSaveCompleteSuccessMessageTimer();

    setTimeout(() => {
      this.isSavedRecently = false;
      this.clearAutoSaveCompleteSuccessMessageTimer();
    }, this.autoSaveCompleteSuccessMessageTimeout);
  }
}
